import { useState, useEffect } from 'react';
import { doctorService } from '../services/api';

export const useDoctors = (category = null, params = {}) => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDoctors = async () => {
    try {
      setLoading(true);
      setError(null);
      
      let response;
      if (category) {
        response = await doctorService.getByCategory(category, params);
      } else {
        response = await doctorService.getAll(params);
      }
      
      setDoctors(response.data.doctors || []);
    } catch (err) {
      console.error('Error fetching doctors:', err);
      if (err.message === 'Request timeout') {
        setError('Request timed out. Please check your internet connection and try again.');
      } else {
        setError(err.message);
      }
      setDoctors([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDoctors();
  }, [category, JSON.stringify(params)]);

  return { doctors, loading, error, refetch: fetchDoctors };
};

export const useBestDoctors = (params = {}) => {
  return useDoctors('bestDoctors', { ...params, limit: 100 });
};

export const useTurkeyDoctors = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('turkeyDoctors', { ...params, limit: 100 });
  
  // Additional filter to ensure only Turkey doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'turkey'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useThailandDoctors = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('thailandDoctors', { ...params, limit: 100 });
  
  // Additional filter to ensure only Thailand doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'thailand'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useIndiaDoctors = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('indiaDoctors', { ...params, limit: 100 });
  
  // Additional filter to ensure only India doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'india'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useSouthKoreaDoctors = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('southKoreaDoctors', { ...params, limit: 100 });
  
  // Additional filter to ensure only South Korea doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'south korea'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useStarDoctorsIndia = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('starDoctorsIndiaData', { ...params, limit: 100 });
  
  // Additional filter to ensure only India doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'india'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useStarDoctorsTurkey = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('starDoctorsTurkeyData', { ...params, limit: 100 });
  
  // Additional filter to ensure only Turkey doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'turkey'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useStarDoctorsSouthKorea = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('starDoctorsSouthKoreaData', { ...params, limit: 100 });
  
  // Additional filter to ensure only South Korea doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'south korea'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useStarDoctorsThailand = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors('starDoctorsThailandData', { ...params, limit: 100 });
  
  // Additional filter to ensure only Thailand doctors show up
  const filteredDoctors = doctors.filter(doctor => 
    doctor.country && doctor.country.toLowerCase() === 'thailand'
  );
  
  return { doctors: filteredDoctors, loading, error, refetch };
};

export const useAllDoctors = (params = {}) => {
  return useDoctors(null, { ...params, limit: 1000 });
};

export const useFeaturedDoctors = (params = {}) => {
  const { doctors, loading, error, refetch } = useDoctors(null, { ...params, limit: 1000 });
  
  // Filter only doctors marked as featured
  const featuredDoctors = doctors.filter(doctor => 
    doctor.featuredBestDoctors === true
  );
  
  // Debug logging
  console.log('All doctors:', doctors.length);
  console.log('Featured doctors:', featuredDoctors.length);
  console.log('Featured doctors data:', featuredDoctors);
  
  return { doctors: featuredDoctors, loading, error, refetch };
};
